/**
 * Rileva il locale dell'utente dal browser
 * @returns Il locale string (es. 'it-IT', 'en-US', ecc.)
 */
function getUserLocale(): string {
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }
  if (
    typeof navigator !== 'undefined' &&
    navigator.languages &&
    navigator.languages.length > 0
  ) {
    return navigator.languages[0];
  }
  return 'it-IT'; // Fallback default
}

/**
 * Rileva il fuso orario dell'utente
 * @returns Il timezone string (es. 'Europe/Rome', 'America/New_York', ecc.)
 */
function getUserTimezone(): string {
  try {
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
      const options = Intl.DateTimeFormat().resolvedOptions();
      return options.timeZone || 'UTC';
    }
  } catch (error) {
    console.warn('Impossibile rilevare il fuso orario:', error);
  }
  return 'UTC'; // Fallback default
}

export function formatTime(datetime: string): string {
  try {
    const date = new Date(datetime);
    const timeZone = getUserTimezone();

    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timeZone
    });
  } catch (error) {
    console.warn("Errore nella formattazione dell'ora");
    return '';
  }
}

export function formattedDate(scheduled: string): string {
  if (!scheduled) return '';

  try {
    const date = new Date(scheduled);
    const timeZone = getUserTimezone();

    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      timeZone: timeZone
    });
  } catch (error) {
    console.error('Errore nella formattazione della data:', error);
    return scheduled;
  }
}

export function formatDateAndTime(datetime: string): string {
  if (!datetime) return '';

  try {
    const date = new Date(datetime);
    const timeZone = getUserTimezone();

    const datePart = date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      timeZone: timeZone
    });
    const timePart = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timeZone
    });
    return `${datePart} ${timePart}`;
  } catch (error) {
    console.warn('Errore nella formattazione di data e ora');
    return '';
  }
}

export function formatSecondsToTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(remainingSeconds).padStart(2, '0');
  return `${mm}:${ss}`;
}

export function formatSecondsToTimeWithMinutes(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  return `${minutes}'`;
}

export function removeParentheses(value: string): string {
  if (!value) return '';
  return value.replace(/\([^)]*\)/g, '');
}
